import React from "react";

const psiFormatter = (values) => {
  return (
    <React.Fragment>
      <span
        style={{
          borderBottom: "1px solid black",
          minWidth: "50px",
          display: "inline-block", // Ensures the width is respected
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {values ? values + " PSI" : ""}
      </span>
    </React.Fragment>
  );
};
const valueFormatter = (values) => {
  // let value = values[0];

  return (
    <span
      style={{
        borderBottom: "1px solid black",
        minWidth: "50px",
        display: "inline-block", // Ensures the width is respected
        textAlign: "center",
        fontWeight: "bold",
      }}
    >
      {values}
    </span>
  );
};
const twoValueFormatter = (value) => {
  const [first, ...rest] = value.split(" ");
  const second = rest.join(" ");

  return second ? (
    <span>
      <span
        style={{
          borderBottom: "1px solid black",
          minWidth: "50px",
          display: "inline-block",
          textAlign: "center",
          fontWeight: "bold",
          marginInlineEnd: "30px",
        }}
      >
        {first}
      </span>
      Added : {second}
    </span>
  ) : (
    <span
      style={{
        borderBottom: "1px solid black",
        minWidth: "50px",
        display: "inline-block",
        textAlign: "center",
        fontWeight: "bold",
      }}
    >
      {first}
    </span>
  );
};

export const getRowsList = (summary) => {
  return Schema;
};

const Schema = [
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "INSPECTION",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "INSPECTION ITEMS",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
      {
        title: "NOTES",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Engine Hours (If Applicable)",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "engHour",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "engHour_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Coolant Level",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkCoolantLvl",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkCoolantLvl_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Engine Oil Level",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: ["chkEngOilLvl", "engineOilLevelAdded"],
        unBold: true,
        formatter: twoValueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkEngOilLvl_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Gearbox Oil (if applicable)",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: ["chkGearboxOil", "gearBoxOilLevelAdded"],
        unBold: true,
        formatter: twoValueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkGearboxOil_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Air Compressor Oil Level",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: ["chkAirCompOilLvl", "airCompressorOilLevelAdded"],
        unBold: true,
        formatter: twoValueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkAirCompOilLvl_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Operation Of Bell And Horn",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkOpBellHorn",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkOpBellHorn_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Operation Of AC Unit, Heaters & Cab Fans",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkOpACUnitHeatCabFans",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkOpACUnitHeatCabFans_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Remove Trash From Cab",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "rmvTrashFromCab",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "rmvTrashFromCab_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Visually Inspect Handbrake",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "visInspHandbrake",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "visInspHandbrake_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Main Reservoir Pressure",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "mainResPres",
        unBold: true,
        formatter: psiFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "mainResPres_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Equalizing Reservoir Pressure",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "eqResPres",
        unBold: true,
        formatter: psiFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "eqResPres_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Brake Pipe Pressure",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "brakePipePres",
        unBold: true,
        formatter: psiFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "brakePipePres_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Operation of Windshield Wipers",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkOpWindshieldWipers",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkOpWindshieldWipers_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Confirm Sanders Are Operating Correctly",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "confSandOperate",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "confSandOperate_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Fire Extinguishers",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkFireExtinguishers",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkFireExtinguishers_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Inspect All Safety Appliances",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "inspAllSafetyAppl",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "inspAllSafetyAppl_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check All Lights (Headlights, Ditch lights, Cab lights, etc.)",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkAllLights",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "chkAllLights_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Brakes Shoes & Piston Travel (Replace & Adjust as Needed)",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "brakeShoesPistonTrv",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "brakeShoesPistonTrv_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Confirm Main Reservoir Drain valves are Operational",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "confMainResDrainOper",
        unBold: true,
        formatter: valueFormatter,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "confMainResDrainOper_notes",
        unBold: true,
        isValueOnly: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/LomotiveInspection33days/LocomotiveSchema.jsx